import { render, staticRenderFns } from "./PublishingContractsWorksEditPanelTopSlot.vue?vue&type=template&id=e96bb56c"
import script from "./PublishingContractsWorksEditPanelTopSlot.vue?vue&type=script&lang=js"
export * from "./PublishingContractsWorksEditPanelTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports